export default __webpack_public_path__ + "static/media/singleCourseHeroImage.7c839e36.png";